// extracted by mini-css-extract-plugin
export var box = "_1g-1";
export var checked = "_1g-2";
export var descriptionSpacer = "_1g-9";
export var disabled = "_1g-3";
export var icon = "_1g-6";
export var input = "_1g-0";
export var labelSpacer = "_1g-8";
export var medium = "_1g-5";
export var small = "_1g-4";
export var text = "_1g-7";